import { Box, Table, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { EmployeeTimePeriodDetailsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  RangeOptionsEnum,
  getUserInfo,
} from 'modules/shift_management/components/ShiftManagement/TimeInsightsSidepanel/Content/utils'

import HoursStackedBars from './HoursStackedBars'
import TotalPlannedTooltip from './TotalPlannedTooltip'

interface Props {
  employeeData: EmployeeTimePeriodDetailsFragment
  rangeType: string
  convertHours: boolean
}

const EmployeeData = ({ employeeData, rangeType, convertHours }: Props) => {
  const [open, toggle] = useToggle(false)

  const totalPlanned = Number(employeeData.plannedHours) + Number(employeeData.paidLeavesHours)
  const totalStandardPlanned =
    Number(employeeData.standardPlannedHours) + Number(employeeData.paidLeavesHours)

  const plannedHours = () => {
    const totalPlannedHours = convertHours ? totalPlanned : totalStandardPlanned

    return i18n.t(
      'shift_management.time_insights.time_balance_content.planned_time.table.planned_hours',
      {
        planned_hours: Number(totalPlannedHours),
      }
    )
  }
  const maxHours = () => {
    const isYearlyView =
      rangeType === RangeOptionsEnum.year ||
      rangeType === RangeOptionsEnum.thisYear ||
      rangeType === RangeOptionsEnum.yearToDate

    const recommendedHours = isYearlyView
      ? Number(employeeData.recommendedHours)
      : Number(employeeData.recommendedHours) - Number(employeeData.bankHolidayHours)

    return i18n.t(
      'shift_management.time_insights.time_balance_content.planned_time.table.max_hours',
      {
        max_hours: Number(recommendedHours),
      }
    )
  }

  return (
    <>
      <Table.Cell colSpan={3}>{getUserInfo(employeeData)}</Table.Cell>
      <Table.Cell colSpan={7}>
        <HoursStackedBars
          employeeData={employeeData}
          rangeType={rangeType}
          convertHours={convertHours}
        />
      </Table.Cell>
      <Table.Cell colSpan={2} padding="s1">
        <Box flexDirection="row">
          <Tooltip.ItemList
            attachment="top center"
            open={open}
            size="auto"
            toggle={toggle}
            backgroundColor="grey800"
          >
            <Text.Normal size="200" weight="medium">
              {plannedHours()}
            </Text.Normal>
            <TotalPlannedTooltip employeeData={employeeData} convertHours={convertHours} />
          </Tooltip.ItemList>
          &nbsp;
          <Text.Normal size="200">/</Text.Normal>
          &nbsp;
          <Text.Normal size="200" weight="medium" color="grey600">
            {maxHours()}
          </Text.Normal>
        </Box>
      </Table.Cell>
    </>
  )
}

export default EmployeeData
